<template>
  <div>
    {{ getSystemNIC(item) }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PrimaryAdapterIP',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('SystemCollection', {
      getSystemNIC: 'getSystemNIC',
    }),
  },
};
</script>
